"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureContextProvider = exports.useRoles = exports.useCanAccessFlag = exports.useAccessFlags = void 0;
const react_1 = __importStar(require("react"));
const Context = (0, react_1.createContext)({ roles: [], flags: new Set() });
Context.displayName = 'FeatureContext';
/** Use where you want to bulk check flags or repeatedly check flags. Returns a Set object that will be the same as long as roles remain the same. */
function useAccessFlags() {
    const { flags } = (0, react_1.useContext)(Context);
    return flags;
}
exports.useAccessFlags = useAccessFlags;
/** Use where you want to check if we can access a single flag */
function useCanAccessFlag(featureFlag) {
    return useAccessFlags().has(featureFlag);
}
exports.useCanAccessFlag = useCanAccessFlag;
function useRoles() {
    const { roles } = (0, react_1.useContext)(Context);
    return roles;
}
exports.useRoles = useRoles;
const FeatureContextProvider = ({ children, roles }) => {
    // unique flags
    const flags = (0, react_1.useMemo)(() => {
        const r = new Set(roles.flatMap(r => { var _a; return (_a = r.features) !== null && _a !== void 0 ? _a : []; }));
        console.log('access flags', r);
        return r;
    }, [roles]);
    return react_1.default.createElement(Context.Provider, { value: { roles, flags } }, children);
};
exports.FeatureContextProvider = FeatureContextProvider;
